/**
 * Public JS
 */

require('./bootstrap');

window.Vue = require('vue');

// Try importing VueRouter first to see if this line fails
const VueRouter = require('vue-router').default;
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'hash',
    routes: [
        {
            path: '/viewing-appointment',
            name: 'viewing-appointment',
            component: require('./components/public/KSRViewingAppointment.vue').default
        },
        {
            path: '/viewing-appointment-checkout/:jobId',
            name: 'viewing-appointment-checkout',
            component: require('./components/public/KSRViewingAppointmentCheckout.vue').default
        },
        {
            path: '/viewing-appointment-form/:jobId',
            name: 'viewing-appointment-form',
            component: require('./components/public/KSRViewingAppointmentForm.vue').default
        },
        {
            path: '/online-offer',
            name: 'online-offer',
            component: require('./components/public/KSROnlineOffer.vue').default
        },
        {
            path: '/online-offer-form/:jobId',
            name: 'online-offer-form',
            component: require('./components/public/KSROnlineOfferForm.vue').default
        },
        {
            path: '/online-offer-checkout/:jobId',
            name: 'online-offer-checkout',
            component: require('./components/public/KSROnlineOfferCheckout.vue').default
        },
        {
            path: '/service',
            name: 'service',
            component: require('./components/public/KSRService.vue').default
        },
        {
            path: '/service-checkout/create',
            name: 'service-checkout',
            component: require('./components/public/KSRServiceCheckout.vue').default
        },
        {
            path: '/service-form/create',
            name: 'service-form',
            component: require('./components/public/KSRServiceForm.vue').default
        },
        {
            path: '/phone-verification',
            name: 'phone-verification',
            component: require('./components/public/KSRPhoneVerification.vue').default
        },
        {
            path: '/thank-you',
            name: 'thank-you',
            component: require('./components/public/KSRBookingThankYou.vue').default
        }
    ]
});

// Import Select2Component
import Select2 from 'v-select2-component';
Vue.component('Select2', Select2);

import VCalendar from 'v-calendar';
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

// Moment
//import moment from 'moment';
window.moment = require('moment-mini');
Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY')
    }
});
Vue.filter('formatTimeSlot', function (value) {
    if (value) {
        return moment(String(value)).format('HH:mm')
    }
});

Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY HH:mm') + ' Uhr'
    }
});

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

// Vue Numeric Input
// https://github.com/JayeshLab/vue-numeric-input
import VueNumericInput from 'vue-numeric-input';
Vue.use(VueNumericInput);

// VueImg
import VueImg from 'v-img';
Vue.use(VueImg);

// Vue Tel Input
import VueTelInput from 'vue-tel-input';
Vue.use(VueTelInput);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component('studio-booking-freistaat', require('./components/public/StudioBookingFreistaat.vue').default);
Vue.component('studio-booking', require('./components/public/StudioBooking.vue').default);
Vue.component('studio-booking-jagdschule', require('./components/public/StudioBookingJagdschule.vue').default);
Vue.component('ksr-booking', require('./components/public/KSRBooking.vue').default);

Vue.component('ksr-cookieless', require('./components/public/KSRCookieless.vue').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    router
});
